import { Check } from '@mui/icons-material';
import { Box, Button, Container } from '@mui/material';
import { ImageUploader, Subheader } from 'components';
import useAcademies from 'hooks/useAcadamies';
import { useNavigate, useParams } from 'react-router-dom';
import AcademyForm from './AcademyForm';
import { useAlerts, usePartners, useUploadFileInMemory } from 'hooks';
import { useEffect } from 'react';
import { validateAcademy } from 'validations/academy';

const AcademyNew = () => {
	const navigate = useNavigate();
	const { id } = useParams();

	const {
		partners,
		findPartners,
		query,
		page,
		sortKey,
		sortDirection,
		handleSort
	} = usePartners({});

	const { showAlertSuccess, showAlertError } = useAlerts();
	const { memoryFile, removeFile, handleUploadFile } = useUploadFileInMemory();
	const { academy, handleChange, createAcademy } = useAcademies({
		id: id
	});

	const handleSaveClick = async () => {
		const valid = validateAcademy(academy);
		if (!valid.isValid) {
			showAlertError(valid.messages[0]);
			return;
		}

		if (!academy.partner_id) {
			showAlertError('select a partner for the academy');
			return;
		}

		await createAcademy(academy, memoryFile);
		navigate('/academies');
	};

	const handleDelete = async (type) => {
		removeFile();
	};

	useEffect(() => {
		findPartners(
			{
				...query,
				sort_key: sortKey,
				sort_direction: sortDirection
			},
			page
		);
	}, [query, page, sortKey, sortDirection]);

	return (
		<div>
			<Subheader
				title="Add Academy"
				buttons={[
					<Button
						color="primary"
						variant="contained"
						startIcon={<Check />}
						onClick={handleSaveClick}
					>
						Save
					</Button>
				]}
			/>
			<Container>
				<Box p={4}>
					<center>
						<ImageUploader
							label="Academy Image Upload"
							imageUrl={academy?.image_url || memoryFile?.image_url?.url}
							handleUpload={(file) => handleUploadFile(file, 'image_url')}
							handleDelete={() => handleDelete('image_url')}
						/>
					</center>
					<AcademyForm
						academy={academy}
						handleChange={handleChange}
						partners={partners}
					/>
				</Box>
			</Container>
		</div>
	);
};

export default AcademyNew;
